export default __webpack_public_path__ + "static/media/Gradient. orange.9f1dd829.png";